

if (window.location.hostname == 'localhost'){
    window.HTTP_ROOT_PATH = 'https://esport.jo/API/data.php?';
    // window.HTTP_ROOT_PATH = 'https://dev72.hoja-crm.com/API/data.php?';
}else{
    window.HTTP_ROOT_PATH = 'https://' + window.location.hostname + '/API/'
}
window.API_DATA = window.HTTP_ROOT_PATH + "data.php";
